const Tres = () => {
    return(
        <div>
                        <div style={{border: 'solid rgba(229, 227, 210)'}}></div>

            <h1>Designfroksot</h1>
            <h4>Publisert: 18.08.2021</h4>
            <p>Velkommen til designfrokost! Det blir avholdt i det store auditoriet Kristen Nygaards hus. Nå har det vært en del sosiale samlinger i forhold til fadderuka, så vær litt ekstra følsom for eventuelle corona-symptomer. </p>
            <h2>Tid: tirsdag 24.08.2021</h2>
            <h2>Sted: Kristen Nygaard store auditorium</h2>
        </div>
    )
}

export default Tres;